import { render, staticRenderFns } from "./NotificationTaskReminder.vue?vue&type=template&id=249b58a2&scoped=true&lang=pug&"
import script from "./NotificationTaskReminder.vue?vue&type=script&lang=js&"
export * from "./NotificationTaskReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249b58a2",
  null
  
)

export default component.exports